import { DbKey } from '../../../../../adl-gen/common/db';
import { UserGroup } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { UserGroupListEntry } from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import { GroupData } from '../../../../../adl-gen/totalinteraction/futurefit/requests';
import { ListEntryWithIdentity, ListFieldInfo } from '../../../common/list/list-types';

export type AppUserGroupListEntry = ListEntryWithIdentity<UserGroup>;

export interface AppUserGroups {
  memberOf: DbKey<UserGroup>[];
  managerOf: DbKey<UserGroup>[];
}

// This one is used for NewAppUserEditor
export const AppUserGroupListView: ListFieldInfo<AppUserGroupListEntry, AppUserGroups>[] = [
  {
    name: 'name',
    label: 'Name',
    kind: 'text',
    displayed: true,
    sortable: true,
    searchable: true
  },
  {
    name: 'isGlobal',
    label: 'Global Group',
    kind: 'checkItem',
    displayed: false,
    align: 'centre'
  },
  {
    name: 'memberOf',
    label: 'Member Of',
    kind: 'toggle',
    toggle: (entry, groups?: AppUserGroups) => {
      if (groups !== undefined) {
        return groups.memberOf.includes(entry.id);
      }
      return false;
    },
    // Disable client admins if usergroup is global
    disabled: entry => entry.isGlobal && entry.identity === 'client-admin',
    displayed: true,
    align: 'centre'
  },
  {
    name: 'managerOf',
    label: 'Manager Of',
    kind: 'toggle',
    toggle: (entry, groups?: AppUserGroups) => {
      if (groups !== undefined) {
        return groups.managerOf.includes(entry.id);
      }
      return false;
    },
    displayed: true,
    align: 'centre'
  },
];

// This is used in NewGroupScreen (summary)
export const UserGroupListView: ListFieldInfo<UserGroupListEntry, GroupData>[] = [
  {
    name: 'name',
    label: 'Name',
    kind: 'link',
    displayed: true,
    sortable: true,
    searchable: true
  },
  {
    name: 'isGlobal',
    label: 'Global Group',
    kind: 'checkItem',
    displayed: true,
    align: 'centre'
  },
  {
    name: 'members',
    label: '# Members',
    kind: 'mapped',
    map: entry => `${entry.members.length}`,
    displayed: true,
    sortable: false,
    align: 'centre'
  },
  {
    name: 'managers',
    label: 'Managers',
    kind: 'selectList',
    map: (entry, data: GroupData) => {
      return entry.managers.length > 0
        ? entry.managers.map(m => {
            const manager = data.userList.find(u => u.id === m.value.appUserId);
            return { label: manager ? manager.value.fullname : 'notfound', value: m.value.appUserId };
          })
        : [{ label: 'None', value: '' }];
    },
    displayed: true,
    align: 'centre'
  }
];



// WEBPACK FOOTER //
// ./src/admin/ui/components/lists/usergroup-list/usergroup-list-view.ts